<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div class="page-head">
      <div>
        <h2>资金账户</h2>
        <p>微信、银行、现金账户余额由不可编辑的资金流水自动汇总</p>
      </div>
      <el-button
        type="primary"
        @click="dialog = true"
      >
        新增账户
      </el-button>
    </div>
    <el-row
      v-loading="loading"
      :gutter="16"
    >
      <el-col
        v-for="item in rows"
        :key="item.id"
        :xs="24"
        :md="12"
        :lg="8"
      >
        <el-card
          shadow="never"
          class="account-card"
        >
          <div class="account-head">
            <div>
              <h3>{{ item.name }}</h3>
              <el-tag type="info">{{ typeText(item.type) }}</el-tag>
            </div>
            <el-switch
              :model-value="Boolean(item.enabled)"
              @change="toggle(item, $event)"
            />
          </div>
          <p>当前余额</p>
          <strong>¥ {{ money(item.balance) }}</strong>
          <small>期初余额 ¥ {{ money(item.opening_balance) }}</small>
        </el-card>
      </el-col>
    </el-row>
    <el-empty
      v-if="!loading && !rows.length"
      description="请先创建资金账户"
    />
    <el-dialog
      v-model="dialog"
      title="新增资金账户"
      width="520px"
    >
      <el-form
        :model="form"
        label-width="100px"
      >
        <el-form-item
          label="账户名称"
          required
        >
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item
          label="账户类型"
          required
        >
          <el-select
            v-model="form.type"
            style="width: 100%"
          >
            <el-option
              label="银行"
              value="BANK"
            />
            <el-option
              label="微信"
              value="WECHAT"
            />
            <el-option
              label="现金"
              value="CASH"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="期初余额">
          <el-input-number
            v-model="form.openingBalance"
            :precision="4"
            :controls="false"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialog = false">取消</el-button>
        <el-button
          type="primary"
          :loading="saving"
          @click="save"
        >
          保存
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import { onMounted, reactive, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { ledgerApi } from '../api'

const rows = ref([])
const loading = ref(false)
const saving = ref(false)
const dialog = ref(false)
const form = reactive({ name: '', type: 'BANK', openingBalance: 0 })
const money = (value) =>
  Number(value || 0).toLocaleString('zh-CN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
const typeText = (type) =>
  ({ BANK: '银行', WECHAT: '微信', CASH: '现金' }[type] || type)
const load = async () => {
  loading.value = true
  try {
    rows.value = await ledgerApi.accounts()
  } catch (error) {
    ElMessage.error(error?.message || '账户加载失败')
  } finally {
    loading.value = false
  }
}
const save = async () => {
  if (!form.name) return ElMessage.warning('请输入账户名称')
  saving.value = true
  try {
    await ledgerApi.createAccount({ ...form })
    ElMessage.success('账户已创建')
    dialog.value = false
    Object.assign(form, { name: '', type: 'BANK', openingBalance: 0 })
    await load()
  } catch (error) {
    ElMessage.error(error?.message || '保存失败')
  } finally {
    saving.value = false
  }
}
const toggle = async (row, enabled) => {
  try {
    await ledgerApi.toggleAccount(row.id, enabled)
    await load()
  } catch (error) {
    ElMessage.error(error?.message || '状态修改失败')
  }
}
onMounted(load)
</script>
<style scoped>
.page-head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.page-head h2 {
  font-size: 24px;
}
.page-head p {
  color: #8a97a8;
  margin-top: 6px;
}
.account-card {
  border: 0;
  margin-bottom: 16px;
}
.account-head {
  display: flex;
  justify-content: space-between;
}
.account-head h3 {
  display: inline-block;
  margin-right: 10px;
}
.account-card p {
  margin: 24px 0 8px;
  color: #94a3b8;
}
.account-card strong {
  display: block;
  font-size: 27px;
  color: #1e293b;
}
.account-card small {
  display: block;
  margin-top: 12px;
  color: #94a3b8;
}
</style>
